import { render } from "./ServiziPrenotatiDataTable.vue?vue&type=template&id=f0913546"
import script from "./ServiziPrenotatiDataTable.vue?vue&type=script&lang=js"
export * from "./ServiziPrenotatiDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__